import classnames from 'classnames'
import { css } from 'emotion'
import { get } from 'lodash'
import * as React from 'react'

import { formatImageUrl, getContrastingColor } from 'embed/utils'

import ThemeConsumer from 'embed/components/ThemeConsumer'
import { SpecialOffer } from 'embed/constants/models'

const compactStyles = require('embed/styles/resultscompact')
const commonStyles = require('embed/styles/results')
const styles = require('./styles')

export interface SpecialOfferListItemCompactProps {
  bestOfferId?: string
  dispatchOfferCta?: (loan: SpecialOffer) => void
  offer: SpecialOffer
}

export class SpecialOfferListItemCompact extends React.Component<SpecialOfferListItemCompactProps> {
  el: HTMLLIElement

  render() {
    const { offer, dispatchOfferCta }: SpecialOfferListItemCompactProps = this.props

    return (
      <ThemeConsumer>
        {({
          ctaStyles,
          colorSecondary,
          colorTextPrimary,
          fontFamilyPrimary,
          borderRadiusLarge,
          borderRadiusSmall,
          colorBorder,
        }) => (
          <li
            data-test-id="specialOffer"
            data-test-val={offer.uuid}
            className={classnames(
              compactStyles.offer,
              compactStyles.specialOffer,
              css`
                border-color: ${colorBorder};
                border-radius: ${borderRadiusLarge};
              `,
            )}
            ref={(el: HTMLLIElement) => (this.el = el)}
          >
            <div className={classnames(compactStyles.offerWrapper, compactStyles.offerWrapper)}>
              <div className={classnames(compactStyles.column, compactStyles.partnerLogo)}>
                <img className={styles.partnerImage} src={formatImageUrl(get(offer, 'partnerImageUrl'))} />
                <p data-test-id="specialOffer_partnerName" className={classnames(styles.partnerName)}>
                  {get(offer, 'partnerName')}
                </p>
              </div>
              <div className={classnames(compactStyles.column, compactStyles.offerColumn)}>
                <div data-test-id="specialOffer_name" className={styles.offerTitle}>
                  {offer.name}
                </div>
                <div data-test-id="specialOffer_desc" dangerouslySetInnerHTML={{ __html: offer.desc }} />
              </div>
              <div className={classnames(compactStyles.column, commonStyles.cta, compactStyles.ctaColumn)}>
                <button
                  className={classnames(
                    commonStyles.button,
                    compactStyles.button,
                    css(`
                    color: ${getContrastingColor(ctaStyles?.backgroundColor, { black: colorTextPrimary })};
                    border-radius: ${borderRadiusSmall};
                    &:hover {opacity: 0.84;}
                  `),
                  )}
                  onClick={dispatchOfferCta?.bind(this, offer)}
                >
                  Continue
                </button>
              </div>
              <div className={classnames(commonStyles.preApprovedSection, compactStyles.preApprovedSection)}>
                <div
                  data-test-id="specialOffer_flag"
                  className={classnames(
                    commonStyles.preApprovedFlag,
                    compactStyles.preApprovedFlag,
                    css`
                      background-color: ${colorSecondary};
                      font-family: ${fontFamilyPrimary};
                      &::after {
                        border-color: ${colorSecondary};
                        border-right-color: transparent;
                      }
                    `,
                  )}
                >
                  Special Offer
                </div>
              </div>
            </div>
          </li>
        )}
      </ThemeConsumer>
    )
  }
}
